import { render, staticRenderFns } from "./addAdminModal.vue?vue&type=template&id=9882cbea&"
import script from "./addAdminModal.vue?vue&type=script&lang=ts&"
export * from "./addAdminModal.vue?vue&type=script&lang=ts&"
import style0 from "./addAdminModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports